import { InjectionToken } from '@angular/core';

export type UploadConfig = {
  acceptedFileTypes: string[];
  acceptedFileTypesDescription: string;
};

export const UPLOAD_CONFIG: InjectionToken<UploadConfig> = new InjectionToken(
  'Config for file uploads'
);
